// extracted by mini-css-extract-plugin
export default {"horizontal":"_3A4UZ","vertical":"_3czza","bullet":"_2ybIo"};